<template>
    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" />
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  props: ['url'],
  data: function () {
    return {
      dropzoneOptions: {
          url: this.url,
          thumbnailWidth: 150,
          maxFilesize: 80,
          dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> Datei hineinziehen oder klicken.",
          headers: { "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute('content') }
      }
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckDropzone.vue